/* Nov 3 (merchant): an oval slider floating along the right side of every scrolling description window.
   Drag the oval, tap the rail to jump, or scroll inside the box as usual; the oval follows. */
(function () {
  function setup(box) {
    if (box.dataset.railReady) return;
    box.dataset.railReady = '1';
    var wrap = document.createElement('div');
    wrap.className = 'desc-wrap';
    box.parentNode.insertBefore(wrap, box);
    wrap.appendChild(box);
    var rail = document.createElement('div');
    rail.className = 'desc-rail';
    rail.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('div');
    thumb.className = 'desc-thumb';
    rail.appendChild(thumb);
    wrap.appendChild(rail);

    function update() {
      var max = box.scrollHeight - box.clientHeight;
      if (max <= 1) { rail.hidden = true; return; }
      rail.hidden = false;
      var railH = rail.clientHeight;
      var h = Math.max(28, railH * box.clientHeight / box.scrollHeight);
      thumb.style.height = h + 'px';
      thumb.style.transform = 'translateY(' + ((railH - h) * box.scrollTop / max) + 'px)';
    }

    function scrollToPointer(clientY, grabOffset) {
      var r = rail.getBoundingClientRect();
      var h = thumb.offsetHeight;
      var ratio = (clientY - r.top - grabOffset) / Math.max(1, r.height - h);
      ratio = Math.min(1, Math.max(0, ratio));
      box.scrollTop = ratio * (box.scrollHeight - box.clientHeight);
    }

    var grab = null;
    thumb.addEventListener('pointerdown', function (e) {
      e.preventDefault(); e.stopPropagation();
      grab = e.clientY - thumb.getBoundingClientRect().top;
      thumb.setPointerCapture(e.pointerId);
    });
    thumb.addEventListener('pointermove', function (e) {
      if (grab === null) return;
      e.preventDefault();
      scrollToPointer(e.clientY, grab);
    });
    function release() { grab = null; }
    thumb.addEventListener('pointerup', release);
    thumb.addEventListener('pointercancel', release);
    rail.addEventListener('pointerdown', function (e) {
      if (e.target !== rail) return;
      e.preventDefault();
      scrollToPointer(e.clientY, thumb.offsetHeight / 2);
    });

    box.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(box);
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 400);
  }

  function init() { document.querySelectorAll('.desc-scroll').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
